


























import Vue from 'vue'
import LetterDisplay from '@/components/letters/DisplayForCockpit.vue'
import Supplemental from '@/components/layout/Collapse.vue'

// FIXME: Briefe müssen neu aus der API geladen werden, er zeigt sonst den Brief nur an, wenn er schon in den Store geladen wurde
export default Vue.extend({
  components: {
    LetterDisplay,
  },
  props: {
    number: {
      type: [String, Number],
      required: true,
    },
    condition: {
      type: String,
      required: true,
      validator(value: string) {
        return ['ipt', 'cbt', 'cr', 'expo', 'counseling'].includes(value)
      },
    },
    caseId: {
      type: String,
      required: true,
    },
  },
  computed: {
    isCounselingP1orP4(): boolean {
      if (this.condition === 'counseling' && (this.number == 1 || this.number == 4)) {
        return true
      }
      return false
    },
    scalingQuestionScore(): string {
      if (this.isCounselingP1orP4) {
        let timeOfMeasurement = this.number == 1 ? 'counseling_p1' : 'counseling_p4'
        let result = this.$store.getters['scaling/findBy']({
          case_id: this.caseId,
          time_of_measurement: timeOfMeasurement,
        })
        if (result == null || result == undefined) {
          return 'N/A'
        }
        return result.score.toString()
      }
      return 'N/A'
    },
  },
  mounted() {
    this.$store.dispatch({ type: 'scaling/fetch' })
  },
})
